export default __webpack_public_path__ + "static/media/lorcana_rare.50fdd365.svg";